// extracted by mini-css-extract-plugin
module.exports = {"main":"search-breadcrumbs_main__tCJaY","phAnimation":"search-breadcrumbs_phAnimation__81ydH"};